<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="$emit('update:visible',false)"
             :close-on-click-modal="false" width="30%" :modal="typemodul">
    <div class="dialog_conwrap">
      <el-tree
              class="filter-tree"
              :props="defaultProps"
              ref="tree"
              :load="loadNode"
              :default-expanded-keys="defaultExpandedKeys"
              lazy
              @node-click="handleNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span v-if="node.data.typeStatus!==1"><i class="iconfont iconbumen"></i>{{node.data.name}}</span>
          <span v-else class="user-tree-list" @click.stop="userlineId(node.data.id,node.data.name)"><i class="iconfont iconyuangong1"></i>{{node.data.name}}</span>
        </span>
      </el-tree>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="saveFnBox" size="small">保存</el-button>
    </div> -->
  </el-dialog>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "chooseDepDialog",
    props: ["visible","typeDialog"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },

    data() {
      return {
        typemodul: '',
        dialogTitle: '',
        dialogVisible: this.visible,
        filterText: "",
        count: "",
        result: [],
        treeflag: true,
        clickData: null,
        defaultProps: {
          children: 'son',
          label: 'name'
        },
        defaultExpandedKeys:[],
        eid: ""
      };
    },
    created() {
      // 1 选择员工 2 选择app管理员 3 招聘选择人员 4 顾问
      let typemodul = true;
      if(this.typeDialog===1){
        this.dialogTitle = '选择员工'
      }else if(this.typeDialog===2){
        this.dialogTitle = '选择app管理员'
      }else if(this.typeDialog===3){
        typemodul = false
        this.dialogTitle = '选择员工'
      }else if(this.typeDialog===4){
        this.dialogTitle = '选择顾问'
      }
      this.typemodul = typemodul
      // this.querydep();
    },
    methods: {
      // 懒加载
      async loadNode(node, resolve) {
        // typeStatus 0 部门 1 员工
        if (node.level === 0) {
          let res = await this.querydep();

          if (res && res.data.code === 0) {
            if (node.level === 0) {
              this.defaultExpandedKeys.push(res.data.top.id)
              this.$set(this.defaultExpandedKeys, 0, res.data.top.id)
              return resolve([
                {name: res.data.top.name, id: res.data.top.id}
              ]);
            } else {
              let deplist = res.data.top.son || [];
              return resolve(deplist);
            }
          } else {
            return resolve([]);
          }
        }
        if (node.level >= 1) {
          if (node.data.typeStatus !== 1) {
            let id = node.data.id;
            let childres = await this.querychilddep(id);
            if (childres && childres.data.code === 0) {
              let department = childres.data.department || []; // department employee
              let employee = childres.data.employee || [];
              // typeStatus 0 部门 1 员工
              for (let i in department) {
                department[i].typeStatus = 0;
              };
              for (let i in employee) {
                employee[i].typeStatus = 1;
              };
              return resolve(department.concat(employee));
            } else {
              return resolve([]);
            }
          }else{
            return resolve([]);
          }
        }
      },
      // 查询部门
      querydep() {
        let params = {};
        return this.axios.post(api.companyadmin_get_alldepartment, params);
      },
      // 查询子部门
      querychilddep(id) {
        let params = {
          depart_id: id
        };
        return this.axios.post(api.companyadmin_get_employee_child, params);
      },
      handleNodeClick(data) {
        this.clickData = data
      },
      saveFnBox() {
        // type 0-官网装修 1-设置专属顾问 
        if (this.type==0) {
          this.dialogVisible = false;         
        } else {
          this.axios.post(api.customer_setCounselor, {
            employee_id: this.eid,
            uid: this.uid
          })
            .then(response => {
              if (response.data.code == 0) {
                this.$message.success('设置成功');
                this.dialogVisible = false;
                this.$emit("updata");
              } 
            })
            .catch(response => {
            });           
        }
      },
      userlineId(id,name){
        this.$emit('userDetail',{id:id,name:name});
      }
    }
  };
</script>

